const loadUserData = async (token, gameId, setBalance) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/getPlayerData`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ token, gameId }),
        });

        const result = await response.json();
        if (result.balance) {
            console.log("Response from API:", result);
            setBalance(result.balance);
            localStorage.removeItem("gameId");
        }
    } catch (error) {
        console.error("Error calling API:", error);
    }
};

export default loadUserData;
